import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { Panel } from 'src/app/enums';
///import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  // { path: '/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
  // { path: '/packages', title: 'Package Management', icon: 'widgets', class: '' },
  // { path: '/overpacks', title: 'Overpack Management', icon: 'settings_applications', class: '' },
  // { path: '/consolidatedshipments', title: 'Consolidated Shipment', icon: 'settings_applications', class: '' },
  // { path: '/binlocations', title: 'Bin Location', icon: 'settings_applications', class: '' },
  { path: '/customers', title: 'Customer', icon: 'people', class: '' },
  // { path: '/users', title: 'User Management', icon: 'people', class: '' },
  // { path: '/invoices', title: 'Invoice Management', icon: '', class: '' },
  // { path: '/warehouse', title: 'Warehouse', icon: '', class: '' },
];



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  menuItems: any[];
  isAdmin: Boolean = false;
  panelOptions = Panel;
  // public scrollbarOptions = { axis: 'yx', theme: 'minimal', scrollInertia: 0, mouseWheelPixels: 30 };
  public isAZ : boolean = false;

  constructor(

    public auth: AuthenticationService,
  ) { }

  ngOnInit(): void {
      // this.menuItems = ROUTES.filter(menuItem => menuItem);
      console.log("sidebar");
      
      this.isAZ = localStorage.getItem("isAZ") ? true : false;
  }

  

  

}
